import { InspectorPanelSettingsFields } from "../InspectorPanelSettingsFields"
import * as Icons from "@nova/component-icons"
import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import { ButtonPrimary } from "@nova/component-btn"
import { clearSelection } from "panels/content/side-panel/slice.new"
import { selectLiveVideoFlightById } from "features/entity-caching/flights/selectors"
import { openVideoFlight } from "plugins/Video/state/thunks"

export const InspectorPanelLiveVideoLayer = ({ id }: { id: string }) => {
    const dispatch = useAppDispatch()
    const flight = useAppSelector(selectLiveVideoFlightById(id))

    if (!flight) return null

    return (
        <>
            <InspectorPanelSettingsFields shouldShowTopBorder={false}>
                {!!flight.recordingPrefix && (
                    <ButtonPrimary
                        title="Replay Stream"
                        RightIcon={Icons.PlayCircle}
                        className="mb-2"
                        onClick={() => {
                            dispatch(clearSelection())
                            dispatch(openVideoFlight({ flightId: id }))
                        }}
                    />
                )}
            </InspectorPanelSettingsFields>
        </>
    )
}
